import React from "react"
import { compose, withProps } from "recompact"
import withQueryParams from "src/hocs/withQueryParams"
import { Box } from "@infotech/uikit-grid"
import NewPlanConstraint from "./NewPlanConstraint"
import ConstraintTab from "./ConstraintTab"
import styles from "./styles.css"

const PlanContainer = ({ id, basicUrl, disableEdit }) => {
  const isNew = Boolean(id === `new`)
  const isPlan = Boolean(basicUrl === `/plans`)
  return (
    <Box loose className={styles.ConstraintWrapper}>
      {isNew ? (
        <NewPlanConstraint isPlan={isPlan} />
      ) : (
        <ConstraintTab
          planId={id}
          basicUrl={basicUrl}
          isDisabled={disableEdit}
        />
      )}
    </Box>
  )
}

const enhancer = compose(
  withQueryParams(),
  withProps(
    props =>
      props.match.params && {
        id: props.match.params.id || props.match.params.planId || props.id,
        basicUrl: props.basicUrl,
      },
  ),
)

export default enhancer(PlanContainer)
